export const HINT_ATTR_DATA = {
  nameAttr: 'data-title',
  body: '[data-title]:hover::before',
  arrow: '[data-title]:hover::after'
}
